module.exports = __webpack_public_path__ + "img/pay.c25a7aad.svg";